import request from '@/utils/request'

/**
 * 查询商品详情
 * @param {Object} params 查询参数
 */
export function queryProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.queryProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询商品规格
 * @param {Object} params 查询参数
 */
export function queryProductSpec(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.queryProductSpec',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询商品评论
 * @param {Object} params 查询参数
 */
export function queryShopAppraise(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopAppraise/queryShopAppraise',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询商品标签
 * @param {Object} params 查询参数
 */
export function queryProductLabel(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.queryProductLabel',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询入库记录
 * @param {Object} params 查询参数
 */
export function queryInoutOrderProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrder.queryInoutOrderProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询盘点记录
 * @param {Object} params 查询参数
 */
export function queryAssetInventoryProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: 'inventory.queryAssetInventoryProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询调拨记录
 * @param {Object} params 查询参数
 */
export function queryAllocationOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/allocationOrder/queryAllocationOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询商品订单
 * @param {Object} params 查询参数
 */
export function queryStoreOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryStoreOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询退货记录
 * @param {Object} params 查询参数
 */
export function queryRefundOrders(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/refundOrder.queryRefundOrders',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询拼团商品
 * @param {Object} params 查询参数
 */
export function listProductGroup(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productGroup.listProductGroup',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询拼团订单
 * @param {Object} params 查询参数
 */
export function listProductGroupOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productGroup.listProductGroupOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询秒杀商品
 * @param {Object} params 查询参数
 */
export function listProductSeckill(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productSeckill.listProductSeckill',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询秒杀订单
 * @param {Object} params 查询参数
 */
export function listProductSeckillOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productSeckill.listProductSeckillOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 回复评价
 * @param {Object} params 回复参数
 */
export function ackAppraise(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopAppraise.ackAppraise',
      method: 'post',
      data: params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}